<template>
  <v-navigation-drawer
    app
    permanent
    left
    width="512"
    style="background-color: #2f6e7c"
    :mini-variant-width="100"
    :expand-on-hover="!isPinned"
    :mini-variant.sync="isMini"
  >
    <div class="d-flex flex-column justify-space-between fill-height">
      <v-container>
        <v-row align="center">
          <v-col cols="8" class="d-flex flex-column align-center px-12">
            <h1 class="mt-4 mb-2 white--text text-h3 text-center">Stories</h1>
          </v-col>
          <v-col cols="4" class="d-flex justify-space-around">
            <v-btn
              v-if="!isMini"
              @click="
                vikyModal = true;
                vikyToken = project.viky.token;
                slug = project.viky.slug;
                fallback = project.fallback;
              "
              color="white"
              x-medium
              text
            >
              <v-icon>mdi-cog-outline</v-icon>
            </v-btn>
            <v-btn
                v-if="!isMini"
                @click="togglePin"
                color="white"
                x-medium
                text
            >
              <v-icon>{{ isPinned ? 'mdi-pin' : 'mdi-pin-off' }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-toolbar v-if="!isMini" dark class="head-context">
          <v-toolbar-title>
            <v-icon
              left
              dark
              icon
              @click="removePin(); $router.push(`/`)"
              v-if="!isMini"
              title="Back to dialogs"
            >
              mdi-subdirectory-arrow-left
            </v-icon>
            <strong>{{ projectName }}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            :to="`/project/${$route.params.id}/chat`"
            target="_blank"
            v-if="!isMini"
            title="Go to chat"
          >
            <v-icon dark>mdi-chat</v-icon>
          </v-btn>
        </v-toolbar>

        <!--MENU DRAWER-->
        <div :style="{
                'max-height': 'calc(100vh - 250px)',
                'overflow-y': !isMini ? 'scroll' : 'visible',
                'overflow-x': 'hidden',
        }">
          <div class="categories" style="margin-top: 15px; ">
            <div v-for="(category, indexCategorie) in categories" :key="category.id" class="category">

              <v-list class="category-header">
                <v-list-item
                    @click="isEditable === category.id ? null : category.collapsed = !category.collapsed"
                    style="padding-left: 0 !important;"
                >
                  <v-list-item-content class="white--text">
                    <v-list-item-title
                        style="color: #fff; font-size: 18px; font-weight: bold; width: 10px; overflow: hidden"
                    >
                      <v-text-field
                          v-if="isEditable === category.id"
                          label="Category Name"
                          v-model="category.name"
                          color="white"
                      ></v-text-field>
                      <span v-else>
                      {{ category.name }}
                    </span>
                    </v-list-item-title>
                  </v-list-item-content>

                  <div>

                    <v-btn
                        v-if="isEditable === category.id"
                        icon
                        text
                        color="white"
                        title="Save changes"
                        @click.stop.prevent="updateCategoryName(category.id, category.name)"
                    >
                      <v-icon color="dark" :medium="isMini">mdi-check</v-icon>
                    </v-btn>

                    <v-btn
                        v-else
                        icon
                        text
                        color="white"
                        title="Edit category"
                        @click.stop.prevent="isEditable = category.id"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                        v-if="isEditable === category.id"
                        icon
                        text
                        color="white"
                        title="Annuler"
                        @click.stop.prevent="closeEditCategory"
                    >
                      X
                    </v-btn>

                    <v-btn
                        v-else
                        icon
                        text
                        color="white"
                        title="Delete category"
                        @click.stop.prevent="removeCategory(category.id)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>

                    <v-btn icon @click.stop.prevent="category.collapsed = !category.collapsed">
                      <v-icon>{{ category.collapsed ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </div>
                </v-list-item>
              </v-list>

              <div v-model="category.submenus"  :id="`category-${category.id}`">
                <v-list
                    v-if="category.collapsed"
                    v-for="(submenu, index) in category.submenus"
                    :key="submenu.id"
                    class="d-flex align-center"
                    style="padding: 0 !important;"
                >
                  <v-list-item
                      @click="openSkill(submenu)"
                      :class="{ 'collapsed': submenu.collapse }"
                      class="submenu-item"
                      @mouseenter="showButtonsOnCategory(category.id, submenu._id)"
                      @mouseleave="hideButtonsOnCategory(category.id, submenu._id)"
                  >

                    <v-icon
                        left
                        icon
                        @click.stop.prevent="removeSkillInCategory(category.id, submenu)"
                        v-if="isHovered"
                        style="position: absolute; left: 0; color: white"
                        title="Exit to category"
                        class="hover-icon"
                    >
                      mdi-subdirectory-arrow-left
                    </v-icon>

                    <v-list-item-icon
                        v-if="$route.params.skillId === submenu._id"
                        style="margin-right: 8px"
                    >
                      <v-icon color="dark" :medium="isMini">mdi-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="white--text p-0">
                      <v-list-item-title
                          class="body-1 text-capitalize"
                          style="width: 10px; overflow: hidden; color: #fff"
                      >
                        <div
                            v-if="submenu.isLatent"
                            style="background: #3796f3; width: 8px; height: 25px;z-index: 10; position: absolute; left: -2px">
                        </div>
                        {{ submenu.name }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-btn icon disabled v-if="submenu.isStart" color="white">
                      <v-icon>mdi-location-enter</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!isMini"
                        icon
                        text
                        color="white"
                        title="Delete story"
                        class="hide"
                        :class="`category-${category.id}-submenu-${submenu._id}`"
                        @click.stop.prevent="removeSkill(submenu)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!isMini"
                        icon
                        text
                        color="white"
                        title="Edit story"
                        class="hide"
                        :class="`category-${category.id}-submenu-${submenu._id}`"
                        @click.stop.prevent="showEditDialog(submenu, category)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!isMini"
                        icon
                        text
                        color="white"
                        title="Duplicate story"
                        class="hide"
                        :class="`category-${category.id}-submenu-${submenu._id}`"
                        @click.stop.prevent="duplicateSkillOnCategory(indexCategorie,index)"
                    >
                      <v-icon>mdi-content-duplicate</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!isMini"
                        icon
                        text
                        color="white"
                        title="Copy story"
                        class="hide"
                        :class="`category-${category.id}-submenu-${submenu._id}`"
                        @click.stop.prevent="copySkill(submenu)"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!isMini"
                        icon
                        text
                        color="white"
                        title="Download all messages"
                        class="hide"
                        :class="`category-${category.id}-submenu-${submenu._id}`"
                        @click.stop.prevent="downloadMessages(submenu, projectName)"
                    >
                      <v-icon>mdi-file-download-outline</v-icon>
                    </v-btn>
                  </v-list-item>
                </v-list>
              </div>
            </div>
          </div>

          <div style="margin: 8px 0; height: 2px; width: 100%; background-color: #cfcfcf"></div>

          <div
              class="skills"
          >
            <div v-model="skills">
              <v-list
                  v-for="(skill, index) in skills"
                  :key="`links-${index}`"
                  :id="`skill-${skill._id}`"
                  class="d-flex align-center"
                  style="padding: 0 !important;"
              >
                <v-list-item
                    @click="openSkill(skill)"
                    class="submenu-item-skill"
                    @mouseenter="showButtons(index)"
                    @mouseleave="hideButtons(index)"
                >
                  <v-list-item-icon v-if="$route.params.skillId === skill._id">
                    <v-icon color="dark" :medium="isMini">mdi-check</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content class="white--text">
                    <v-list-item-title
                        class="body-1 text-capitalize"
                        style="width: 10px; overflow: hidden"
                    >
                      <div
                          v-if="skill.isLatent"
                          style="background: #3796f3; width: 8px; height: 25px;z-index: 10; position: absolute; left: -2px">
                      </div>
                      {{ skill.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-btn icon disabled v-if="skill.isStart" color="white">
                    <v-icon>mdi-location-enter</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="!isMini"
                      icon
                      text
                      color="white"
                      title="Delete story"
                      class="hide"
                      :class="`skill-${index}`"
                      @click.stop.prevent="removeSkill(skill)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="!isMini"
                      icon
                      text
                      color="white"
                      title="Edit story"
                      class="hide"
                      :class="`skill-${index}`"
                      @click.stop.prevent="
                  editDialog = true;
                  currentSkill = skill;
                  newCategory = '';
                "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="!isMini"
                      icon
                      text
                      color="white"
                      title="Duplicate story"
                      class="hide"
                      :class="`skill-${index}`"
                      @click.stop.prevent="duplicateSkill(index)"
                  >
                    <v-icon>mdi-content-duplicate</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="!isMini"
                      icon
                      text
                      color="white"
                      title="Copy story"
                      class="hide"
                      :class="`skill-${index}`"
                      @click.stop.prevent="copySkill(skill)"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="!isMini"
                      icon
                      text
                      color="white"
                      title="Download all messages"
                      class="hide"
                      :class="`skill-${index}`"
                      @click.stop.prevent="downloadMessages(skill, projectName)"
                  >
                    <v-icon>mdi-file-download-outline</v-icon>
                  </v-btn>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </div>

        <v-row align="center" style="position: absolute; bottom: 0">
          <v-col cols="12">
            <v-text-field
              v-if="!isMini"
              v-model="skillName"
              style="width: 480px"
              color="white"
              @keyup.enter="addSkill"
              dark
              placeholder="Story Name"
            >
              <template v-slot:append-outer>
                <v-btn icon text color="white" @click="addSkill">
                  <v-icon large>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-dialog v-model="editDialog" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Story</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Story Name"
            v-model="currentSkill.name"
          ></v-text-field>
          <v-switch
            v-model="currentSkill.isStart"
            label="Start Story"
          ></v-switch>
          <v-switch
            v-model="currentSkill.isLatent"
            label="Latent Dialogue"
          ></v-switch>
          <v-combobox
              ref="combobox"
              v-model="newCategory"
              :items="copyCategory"
              label="Category"
              item-text="name"
              item-value="id"
              small-chips
              @keyup.native="handleKeyup"
              hide-selected
              hide-no-data
          ></v-combobox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editDialog = false"
            >Close</v-btn
          >
          <div>
            <v-btn
                v-if="!saveEditSkill"
                color="blue darken-1"
                text
                @click="editSkill();addCategory()"
            >Save</v-btn>
            <v-btn
                v-else
                color="blue darken-1"
                style="width: 70px"
            >
              <v-progress-circular
                  indeterminate
                  size="14"
                  width="2"
              />
            </v-btn>
          </div>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="vikyModal" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Dialog</span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Viky Token" v-model="vikyToken"></v-text-field>
          <v-text-field label="Viky Slug" v-model="slug"></v-text-field>
          <v-text-field
            label="Fallback Message"
            v-model="fallback"
          ></v-text-field>
          <v-row>
            <v-col>
              <v-btn
                style="width: 100%"
                color="success"
                @click="exportBot()"
                dark
              >
                Export
                <v-icon right dark>mdi-application-export</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="vikyModal = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" text @click="editProject">update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="copyStoryDialog" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Copy Story to Dialog</span>
        </v-card-title>
        <v-card-text>
<!--          <v-text-field
              label="Story Name"
              v-model="storyName"
          ></v-text-field>-->
          <span class="storyname">Story Name : <b>{{ storyName }}</b></span>
          <v-select
              :items="allProjects"
              item-text="name"
              item-value="_id"
              label="Dialogs List"
              v-model="selectedDialog"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="copyStoryDialog = false"
          >Close</v-btn
          >
          <v-btn color="blue darken-1" :disabled="!selectedDialog.length" text @click="handleCopy">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";
import dateFomrat from "dateformat";
import draggable from 'vuedraggable';
export default {
  components: {
    draggable,
  },
  data() {
    return {
      showItems: true,
      isPinned:  localStorage.getItem('isPinned') === 'true',
      saveEditSkill: false,
      categories: [],
      copyCategory: [],
      newCategory: '',
      vikyModal: false,
      isMini: true,
      skillName: "",
      skills: [],
      currentSkill: {},
      editDialog: false,
      project: {},
      vikyToken: "",
      slug: "",
      fallback: "",
      projectName: "",
      copyStoryDialog: false,
      storyName: "",
      storyId: "",
      allProjects: [],
      selectedDialog: "",
      isHovered: false,
      isEditable: "",
      currentCadtegoryId: ""
    };
  },

  methods: {
    ...mapActions({
      getNodes: "http/nodes/getNodes",
      get: "http/skills/get"
    }),
    handleKeyup(event) {
      this.showItems = event.key !== 'Enter';
    },
    getIsPinnedFromLocalStorage() {
      return localStorage.getItem('isPinned') === 'true';
    },
    togglePin() {
      this.isPinned = !this.isPinned;
      localStorage.setItem('isPinned', this.isPinned)
    },
    removePin() {
      localStorage.removeItem('isPinned');
    },
    closeEditCategory() {
      this.isEditable = null;
    },
    //COPY STORY TO DIALOG
    async handleCopy() {
      console.log(this.selectedDialog, this.storyId);

      let payload = {
        project: this.selectedDialog
      }
      await this.$http
          .post(`/skills/${this.storyId}/copy`, payload)
          .then(({ data }) => {
            this.$notify({
              type: "success",
              text: "Copy story to dialog successfully",
            });
            this.copyStoryDialog = false;
          })
          .catch((err) => {
            this.importModal = false;
            this.bot = "";
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },
    getAllProject() {
      return this.$http.get(`/projects`).then(({ data }) => {
        const projectId = this.$route.params.id
        this.allProjects = data.filter(d => d._id !== projectId);
      });
    },
    showEditDialog(submenu, category) {
      this.editDialog = true;
      this.currentSkill = submenu;
      this.currentCadtegoryId = category.id;
      this.newCategory = this.categories.find(c => c.id === category.id);
    },
    async getCategoryByProjectId() {
      const projectId = this.$route.params.id;
      this.categories = []
      try {
        const { data } = await this.$http.get(`projects/${projectId}/categories`)
        this.categories = data.map(d => ({
          id: d._id,
          name: d.name,
          collapsed: false,
          submenus: this.skills.filter(skill => d.skills.some(id => skill._id === id)),
        }))
        this.copyCategory = this.categories;
        const categorizedSkillsIds = this.categories.flatMap(category => category.submenus.map(skillID => skillID._id));
        this.skills = this.skills.filter(skill => !categorizedSkillsIds.includes(skill._id));
      } catch(error) {
        console.error('Error occured while fetching categories:', error)
      }
    },
    async addCategory() {
      // Vérifier si on a une nouvelle catégorie ou une existante
      this.saveEditSkill = true
      if (!this.newCategory) {
        this.newCategory = this.$refs.combobox.internalSearch;
      }
      const isNewCategory = typeof this.newCategory === 'string';

      const payload = {
        "name": isNewCategory ? this.newCategory : (this.newCategory !== undefined ? this.newCategory.name : ""),
        "project": this.$route.params.id
      };

      try {
        // Vérifie si on a une compétence actuelle
        if (this.currentSkill) {
          const skillId = this.currentSkill._id;
          // Si la nouvelle catégorie est déjà existante et a des compétences,
          // on met à jour seulement la catégorie de la compétence
          if (this.newCategory !== undefined) {
            if (!isNewCategory) {
              await this.updateCategory(skillId, this.newCategory.id);
            } else {
              const { data } = await this.$http.post('/categories/', payload);
              this.saveEditSkill = false;
              await this.updateCategory(skillId, data._id);
            }
          } else {
            // When no new category is specified, delete skill from current category
            await this.$http.delete(`categories/${this.currentCadtegoryId}/skills/${this.currentSkill._id}`);
          }
        }
        this.getSkills().then(() =>  this.getCategoryByProjectId())

        this.newCategory = '';
      } catch(error) {
        console.error('Error occured while adding category:', error);
      }
    },

    async updateCategory(skillId, categoryId) {
      try {
        await this.$http.put(`/skills/${skillId}/category`,{ category: categoryId });
      } catch(response) {
        console.error('Error occured while updating category:', response.data);
      }
    },
    showButtons(index) {
      const domId = `skill-${index}`;
      const buttons = document.getElementsByClassName(domId);
      buttons.forEach((button) => button.classList.remove("hide"));
    },
    hideButtons(index) {
      const domId = `skill-${index}`;
      const buttons = document.getElementsByClassName(domId);
      buttons.forEach((button) => button.classList.add("hide"));
    },
    showButtonsOnCategory(categoryId, submenuId) {
      this.isHovered = true
      const domId = `category-${categoryId}-submenu-${submenuId}`;
      const buttons = document.getElementsByClassName(domId);
      buttons.forEach((button) => button.classList.remove("hide"));
    },
    hideButtonsOnCategory(categoryId, submenuId) {
      this.isHovered = false
      const domId = `category-${categoryId}-submenu-${submenuId}`;
      const buttons = document.getElementsByClassName(domId);
      buttons.forEach((button) => button.classList.add("hide"));
    },
    async downloadMessages(skill, projectName) {
      const nodes = await this.getNodes(skill._id);
      const actions = nodes.map((x) => x.actions);
      const allMessages = [];

      for (let action of actions) {
        const tmp = action.filter((x) => x.actionType === "message");
        if (tmp.length) {
          allMessages.push(tmp[0].args[0]);
        }
      }
      const date = dateFomrat(new Date(), "dd-mm-yyyy");
      allMessages.forEach(
        (element, index) => (allMessages[index] = "¬ " + element.trim())
      );
      if (allMessages.length) {
        this.download(
          `[${projectName}][${skill.name}]_Messages_${date}.txt`,
          allMessages.join("\n")
        );
      } else {
        this.$fire({
          title: "Oops.. Empty skill",
          text: "This skill has no messages",
          type: "error",
          timer: 3000,
        });
      }
    },
    openSkill(skill) {
      if (this.$route.params.skillId !== skill._id) {
        localStorage.removeItem("panzoom_position");
        this.skillId = this.$route.params.skillId;
        this.$router.push(
          `/projects/${this.$route.params.id}/skills/${skill._id}`
        );
        location.reload();
      }
    },
    getProject() {
      return this.$http
        .get(`/projects/${this.$route.params.id}`)
        .then(({ data }) => {
          this.project = data;
          this.projectName = data.name;
        });
    },
    download(filename, text) {
      const element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    exportBot() {
      return this.$http
        .get(`/projects/export/${this.$route.params.id}`)
        .then(({ data }) => {
          const projectName = data?.project?.name;
          const currentDate = this.formatDateToDDMMYYYY(new Date());
          this.download(
            `${projectName}-${currentDate}.json`,
            JSON.stringify(data)
          );
        });
    },




    getSkills() {
      return this.get({ projectId: this.$route.params.id })
          .then((data) => {
            this.skills = data.sort((a, b) =>
                      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                  );
          })
    },
    addSkill() {
      if (this.skillName?.length > 0) {
        this.$http
          .post(`/projects/${this.$route.params.id}/skills`, {
            name: this.skillName,
          })
          .then(() => {
            this.getSkills().then(() => {
              this.skillName = "";
              this.getCategoryByProjectId()
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
      }
    },
    async duplicateSkill(index) {
      let newSkillName = this.skills[index]?.name + '-COPY' || '';
      await this.$http
          .post(`/projects/${this.$route.params.id}/skills/duplicate`, {
            name: newSkillName,
            skillId: this.skills[index]?._id
          })
          .then((data) => {
            let skill = data?.data
            this.skills.push(skill);
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },
    async duplicateSkillOnCategory(categoryId, index) {
      let newSkillName = this.categories[categoryId].submenus[index]?.name + '-COPY' || '';
      await this.$http
          .post(`/projects/${this.$route.params.id}/skills/duplicate`, {
            name: newSkillName,
            skillId: this.categories[categoryId].submenus[index]._id
          })
          .then((data) => {
            if (data && data.data) {
              let skill = data.data;
              this.skills.push(skill);
              //this.categories.submenus.push(skill._id);
            } else {
              console.error('Response or response.data is undefined');
            }
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },
    copySkill(skill) {
      this.getAllProject()
      this.storyName = skill.name
      this.storyId = skill._id
      this.copyStoryDialog = true
    },
    editSkill() {
      this.saveEditSkill = true;
      if (this.currentSkill?._id) {
        this.$http
          .put(
            `/projects/${this.$route.params.id}/skills/${this.currentSkill._id}`,
            {
              name: this.currentSkill.name,
              isStart: this.currentSkill.isStart,
              isLatent: this.currentSkill.isLatent,
            }
          )
          .then(() => {
            this.getSkills().then(() => {
              this.editDialog = false;
              this.currentSkill = {};
              this.saveEditSkill = false;
              //this.getCategoryByProjectId()
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
            this.saveEditSkill = false;
          });
      }
    },
    editProject() {
      this.project.viky.token = this.vikyToken;
      this.project.viky.slug = this.slug;
      this.project.fallback = this.fallback;
      this.$http
        .put(`/projects/${this.$route.params.id}`, this.project)
        .then(() => {
          this.getProject().then(() => {
            this.vikyModal = false;
            this.vikyToken = "";
            this.slug = "";
            this.fallback = "";
          });
        })
        .catch((err) => {
          this.$notify({ type: "error", text: err.response.data.message });
        });
    },
    updateCategoryName(idCategory, name) {
      console.log('name cat', name);
      console.log(' idCategoryname cat', idCategory);
      this.$confirm(
          `Are you sure you want to change name the category <strong>${this.categories.find(c => c.id === idCategory).name}</strong> ?`
      ).then((res) => {
        if (res) {
          this.$http
              .put(`/categories/${idCategory}`, {name})
              .then(() => {
                this.getSkills()
                    .then(() => {
                      this.getCategoryByProjectId();
                    })
                this.isEditable = null
              })
              .catch(err => {
                console.log('Erreur lors de la suppression de la catégorie :', err);
              });
        }
      })
    },
    removeCategory(idCategory) {
      this.$confirm(
          `Are you sure you want to delete the category <strong>${this.categories.find(c => c.id === idCategory).name}</strong> ?`
      ).then((res) => {
          if (res) {
            this.$http
                .delete(`/categories/${idCategory}`)
                .then(() => {
                  this.getSkills()
                      .then(() => {
                        this.getCategoryByProjectId();
                      })
                })
                .catch(err => {
                  console.log('Erreur lors de la suppression de la catégorie :', err);
                });
          }
        }
      )
    },
    removeSkillInCategory(categoryId, skill) {

      this.$confirm(
          `Are you sure you want to delete the skill <strong>${skill.name}</strong> in category ?`
      ).then((res) => {
        if (res) {
          this.$http
              .delete(`categories/${categoryId}/skills/${skill._id}`)
              .then(() => {
                this.getSkills()
                    .then(() => {
                      this.getCategoryByProjectId();
                    })
              })
              .catch(err => {
                console.log('Erreur lors de la suppression du skill :', err);
              });
        }
      })
    },
    removeSkill(skill) {
      this.$confirm(
        `Are you sure you want to delete the skill <strong>${skill.name}</strong> ?`
      ).then((res) => {
        if (res) {
          this.$http
            .delete(`/projects/${this.$route.params.id}/skills/${skill._id}`)
            .then(() => {
              this.getSkills().then(() => {
                if (
                  this.$route.params.skillId === skill._id &&
                  this.skills[0]._id
                ) {
                  this.$router.push(
                    `/projects/${this.$route.params.id}/skills/${this.skills[0]._id}`
                  );
                }
                this.getCategoryByProjectId()
              });

            })
            .catch((err) => {
              this.$notify({ type: "error", text: err.response.data.message });
            });
        }
      });
    },
    formatDateToDDMMYYYY(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
  watch: {
    // Cette fonction s'exécute chaque fois que `currentNodes` change
    categories: {
      immediate: true,
      handler(newValue) {
        // Vérifiez si newValue (la nouvelle valeur de `currentNodes`) existe
        if (newValue) {
          const categorizedSkillsIds = this.categories.flatMap(category => category.submenus.map(skillID => skillID._id));
          this.skills = this.skills.filter(skill => !categorizedSkillsIds.includes(skill._id));
        }
      }
    },
    currentSkill: {
      immediate: true,
      handler(newValue) {
        // Vérifiez si newValue (la nouvelle valeur de `currentNodes`) existe
        if (newValue) {
          const categorizedSkillsIds = this.categories.flatMap(category => category.submenus.map(skillID => skillID._id));
          this.skills = this.skills.filter(skill => !categorizedSkillsIds.includes(skill._id));
        }
      }
    },
    showItems(newValue) {
      if (!newValue) {
        this.copyCategory = [];
      } else {
        this.copyCategory = this.categories
      }
    }
  },
  mounted() {
    this.isPinned = this.getIsPinnedFromLocalStorage();
    this.isMini = !this.isPinned;
  },
  beforeMount() {
    this.getSkills()
        .then(() => {
          this.getCategoryByProjectId();
        })
        .catch((error) => {
          // Géré l'erreur ici
        });
    this.getProject();
  },
};
</script>

<style scoped>
.skills::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #2f6e7c;
}

.skills::-webkit-scrollbar {
  width: 5px;
  background-color: #2f6e7c;
}

.skills::-webkit-scrollbar-thumb {
  background-color: #ffffff;
}

.head-context {
  border-radius: 10px 10px 0 10px;
  height: 5%;
}

.hide {
  visibility: collapse;
}

.storyname {
  font-size: 18px;
}

.submenu-item{
  padding: 0 25px;
}

.submenu-item:hover,
.submenu-item-skill:hover{
  background-color: rgba(255, 255, 255, 0.1);  /* Remplacez avec la couleur de votre choix */
  border-radius: 5px;
}
.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  padding-left: 15px;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
}

.category-header:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.hover-icon {
  display: none;
}

.submenu-item:hover .hover-icon {
  display: inline-block;
}

</style>
